/**
 * Human-readable build duration (#GR18 "time per site"). Sums of builds.duration_ms
 * → "1h 12m" / "4m 30s" / "45s". Hour-scale drops seconds (noise at that scale);
 * minute-scale keeps them. Non-finite / negative / zero → "0s".
 */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '0s';
  const totalSec = Math.round(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}
